<template>
    <div class="all-news-list">
        <div class="all-news-opration">
            <el-input placeholder="请输入名称" v-model="queryParams.keywords" prefix-icon="el-icon-search"
                      style="width: 250px"></el-input>
            <el-button style="margin-left: 10px" type="danger" @click="searchNews">搜索</el-button>
            <el-select style="float: right" :value="query.language"
                       @change="handleQueryChange('language', $event)"
                       placeholder="请选择">
                <el-option v-for="item in languageList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
            <div style="float: right">
                <el-select v-model="queryParams.sortType" @change="searchNews" placeholder="排序方式">
                    <el-option label="创建时间降序" value="1"></el-option>
                    <el-option label="发布时间降序" value="2"></el-option>
                    <el-option label="点击量降序" value="3"></el-option>
                </el-select>
                <el-select style="float: right" v-model="queryParams.sourceType" placeholder="请选择数据来源" @change="searchNews">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="APHA" value="APHA"></el-option>
                    <el-option label="聚合器" value="POLYMER"></el-option>
                    <el-option label="链闻" value="LIAN_WEN"></el-option>
                    <el-option label="金色财经" value="JIN_SE_CAI_JING"></el-option>
                    <el-option label="币世界" value="BI_SHI_JIE"></el-option>
                </el-select>
                <el-select :value="queryParams.newsStatus" @change="handleNewsStatusChange($event)" placeholder="状态">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="待审核" value="TO_BE_REVIEWED"></el-option>
                    <el-option label="已发布" value="RELEASE"></el-option>
                    <el-option label="未通过" value="NO_PASS"></el-option>
                    <el-option label="已下架" value="DISMOUNT"></el-option>
                </el-select>
            </div>
        </div>

        <el-tabs v-model="newsType" @tab-click="handleNewsTypeChange" style="margin-top: 20px">
            <el-tab-pane label="所有" name="ALL"></el-tab-pane>
            <el-tab-pane label="文章" name="ARTICLE"></el-tab-pane>
            <el-tab-pane label="快讯" name="NEWS"></el-tab-pane>
        </el-tabs>

        <div class="all-news-list">
            <el-table class="all-news-table" border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                      :data="newsList" :row-key="() => Math.random()">
                <el-table-column label="状态" fixed="left" min-width="150px" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span :class="getStatusClass(scope.row.status)">{{scope.row.status | formatState}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="columnDetail.columnName" label="栏目" min-width="150px"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column prop="newsTitle" label="标题" min-width="300px" show-overflow-tooltip></el-table-column>
                <el-table-column label="文章链接" width="200px" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-popover
                                placement="top"
                                width="500"
                                trigger="click"
                                :content="scope.row.shareUrl">
                            <span slot="reference">{{scope.row.shareUrl}}</span>
                        </el-popover>

                    </template>
                </el-table-column>
                <el-table-column label="标签" max-width="300px" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-tag type="info" style="margin-right: 5px;margin-bottom: 5px"
                                v-for="item in scope.row.labelDetails"
                                :key="item.id">{{item.labelName}}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="是否推荐" min-width="100px">
                    <template slot-scope="scope">
                        <span>{{scope.row.recommend | formatRecommend}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="是否置顶" min-width="100px">
                    <template slot-scope="scope">
                        <span>{{scope.row.topping | formatRecommend}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="sourceType" label="数据来源" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{scope.row.sourceType | formatSourceType}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="提交时间" width="200px">
                    <template slot-scope="scope">
                        <span>{{scope.row.createTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="发布时间" width="200">
                    <template slot-scope="scope">
                        <span>{{scope.row.publishTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="createrName" label="提交人" width="150px"></el-table-column>
                <el-table-column prop="publisherName" label="审核人" width="150px"></el-table-column>
                <el-table-column prop="hits" label="点击量" width="200px"></el-table-column>
                <el-table-column label="操作" fixed="right" width="280px">
                    <template slot-scope="scope">
                        <el-button type="primary" @click="checkNews(scope.row)">查看</el-button>
                        <el-button type="primary" @click="editNews(scope.row)">编辑</el-button>
                        <el-button type="danger" v-if="scope.row.status=='TO_BE_REVIEWED'" @click="deleteNews(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="margin-top: 30px"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="queryParams.page"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="queryParams.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import '../store';
    import {mapMutations, mapState} from 'vuex';
    import api from '../api';

    export default {
        name: "AllTask",
        data() {
            return {
                newsList: [], //数据列表
                total: 0, //总条数
                queryParams: { //查询参数
                    keywords: "",
                    lang: "",
                    newsType: "",
                    newsStatus: "",
                    sourceType: "",
                    sortType: "1",
                    page: 1,
                    size: 10
                },
                newsType: "ALL",
            }
        },
        computed: {
            ...mapState('cmsManage', ['languageList', 'query'])
        },
        mounted() {

        },
        filters: {
            formatState(state) {
                switch (state) {
                    case 'TO_BE_REVIEWED':
                        return "待审核";
                    case 'RELEASE':
                        return "已发布";
                    case 'NO_PASS':
                        return "未通过";
                    case 'DISMOUNT':
                        return "已下架";
                }
            },
            formatRecommend(state) {
                switch (state) {
                    case 0:
                        return "是";
                    case 1:
                        return "否";
                }
            },
            formatSourceType(state) {
                switch (state) {
                    case 'APHA':
                        return "APHA";
                    case 'LIAN_WEN':
                        return "链闻";
                    case 'JIN_SE_CAI_JING':
                        return "金色财经";
                    case 'BI_SHI_JIE':
                        return "币世界";
                }
            }
        },
        methods: {
            ...mapMutations('cmsManage', ['changeQuery']),
            handleQueryChange(type, value) {
                this.changeQuery({
                    ...this.query,
                    [type]: value
                });
                this.queryParams.page = 1;
                this.queryParams.lang = value;
                this.getWaitNewsList(this.queryParams);
            },
            handleNewsTypeChange() {
                this.queryParams.page = 1;
                this.queryParams.newsType = this.newsType != 'ALL' ? this.newsType : '';
                this.getWaitNewsList(this.queryParams);
            },
            handleNewsStatusChange(value) {
                this.queryParams.page = 1;
                this.queryParams.newsStatus = value;
                this.getWaitNewsList(this.queryParams);
            },
            handleSizeChange(val) {
                this.queryParams.size = val;
                this.getWaitNewsList(this.queryParams);
            },
            handleCurrentChange(val) {
                this.queryParams.page = val;
                this.getWaitNewsList(this.queryParams);
            },
            getWaitNewsList(param) {
                api.getWaitNewsList(param).then(({data}) => {
                    this.newsList = data.records;
                    this.total = data.total;
                });
            },
            searchNews() {
                this.queryParams.page = 1;
                this.getWaitNewsList(this.queryParams);
            },
            getStatusClass(state) {
                switch (state) {
                    case 'TO_BE_REVIEWED':
                        return "blue";
                    case 'RELEASE':
                        return "";
                    case 'NO_PASS':
                        return "red";
                    case 'DISMOUNT':
                        return "green";
                }
            },
            checkNews(row) {
                this.$router.push({
                    path: '/cms/manage/review/detail/newsDetail',
                    query: {
                        id: row.id,
                        keywords: this.queryParams.keywords,
                        lang: this.queryParams.lang,
                        newsType: this.queryParams.newsType,
                        newsStatus: this.queryParams.newsStatus,
                        page: this.queryParams.page,
                        size: this.queryParams.size
                    }
                });
            },
            editNews(row) {
                if (row.newsType == "ARTICLE") {
                    this.$router.push({
                        path: '/cms/manage/content/articleSimplify',
                        query: {
                            id: row.id
                        }
                    });
                } else if (row.newsType == "NEWS") {
                    this.$router.push({
                        path: '/cms/manage/content/newsSimplify',
                        query: {
                            id: row.id
                        }
                    });
                }
            },
            deleteNews(row){
                this.$confirm('确认删除吗？数据将从库中彻底删除！', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.deleteNews({id: row.id}).then(({data}) => {
                        this.getWaitNewsList(this.queryParams);
                        this.$message.success('删除成功！');
                    });
                }).catch(() => {
                });
            }
        },
        created() {
            this.queryParams.lang = this.query.language;
            this.getWaitNewsList(this.queryParams);
        }
    }
</script>


<style type="text/css">
    .all-news-list .el-tabs__nav-wrap::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 2px;
        background-color: rgba(245, 249, 255, 0);
        z-index: 1;
    }
</style>
<style lang="less" scoped>
    .all-news-list {

        .all-news-list {
            border: 1px solid #f2ece2;
            clear: both;
            width: 100%;
            .all-news-table {

                .red {
                    color: #EC6D56;
                }
                .blue {
                    color: #406CE9;
                }
                .green {
                    color: #6dec82;
                }
            }
        }
    }
</style>